import React from 'react'
import PropTypes from 'prop-types'
import ContentBox from '../../../layout/component/ContentBox'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import Select from '../../../form/component/Select'
import LabelInput from '../../../form/component/LabelInput'
import { SIZE_LIST } from '../../state/detail/const'
import currentUserHasAccess from '../../../../util/widget-helper'
import { TRAY_SIZE_WIDGET } from '../../../process/ui-definition/process-ui'


const TraySize = ({ readOnly, customer, changeCustomer, saveCustomer }) => {
    if (!currentUserHasAccess(TRAY_SIZE_WIDGET)) {
        return null
    }

    return (
        <ContentBox title="Tray Size">
            <Row>
                <Column size={6}>
                    <LabelInput label="Upper">
                        <Select object={customer}
                            name="upperTraySize"
                            valueList={SIZE_LIST}
                            addEmpty={!customer.upperTraySize}
                            readOnly={readOnly}
                            onChange={(name, value) => {
                                changeCustomer(name, value)
                                saveCustomer()
                            }}/>
                    </LabelInput>
                </Column>
                <Column size={6}>
                    <LabelInput label="Lower">
                        <Select object={customer}
                            name="lowerTraySize"
                            valueList={SIZE_LIST}
                            addEmpty={!customer.lowerTraySize}
                            readOnly={readOnly}
                            onChange={(name, value) => {
                                changeCustomer(name, value)
                                saveCustomer()
                            }}/>
                    </LabelInput>
                </Column>
            </Row>
        </ContentBox>
    )
}

TraySize.propTypes = {
    readOnly: PropTypes.bool,
    customer: PropTypes.object.isRequired,
    changeCustomer: PropTypes.func.isRequired,
    saveCustomer: PropTypes.func.isRequired,
}

export default TraySize



// WEBPACK FOOTER //
// ./src/modules/customer/component/detail/TraySize.js